export default __webpack_public_path__ + "static/lozenge-dropdown-do-1-dark-bb2c3d702bd5509644b1e164d16c3a13.png";